<template>
    <page>
        <module>
            <view-list
                ref="view"
                work-type="35"
                selector
            >
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="发货单号">
                            <c-input name="delivery_no"></c-input>
                        </m-search-item>
                        <m-search-item label="收货人">
                            <c-input name="receiver_name"></c-input>
                        </m-search-item>
                        <m-search-item label="收货人手机">
                            <c-input name="receiver_phone"></c-input>
                        </m-search-item>
                        <m-search-item label="订单号">
                            <c-input name="order_no"></c-input>
                        </m-search-item>
                        <m-search-item label="快递单号">
                            <c-input name="express_no"></c-input>
                        </m-search-item>
                        <m-search-item label="快递公司">
                            <c-select name="express_company_code" :options="logisticsOptions"></c-select>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_delivery_batch_ship')" prepend-icon="tf-batch" @click="batchShip()">批量发货</c-button>
                    <c-button v-if="auth('b_delivery_print_electronic')" prepend-icon="tf-print" @click="batchApplyWaybill()">生成电子面单</c-button>
                    <c-button v-if="auth('b_delivery_print')" prepend-icon="tf-print" @click="batchPrintWaybill()">批量打印</c-button>
                    <c-button v-if="auth('b_delivery_light')" prepend-icon="tf-light" @click="openLightDialog()">灯控</c-button>
                    <!--列表导出（与列表同DAO同条件口径）-->
                    <c-button v-if="auth('b_delivery_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_delivery_batch_ship')" color="main" prepend-icon="tf-batch" @click="batchShip(data)">批量发货</c-button>
                    <c-button v-if="auth('b_delivery_print_electronic')" color="main" prepend-icon="tf-print" @click="batchApplyWaybill(data)">生成电子面单</c-button>
                    <c-button v-if="auth('b_delivery_print')" color="main" prepend-icon="tf-print" @click="batchPrintWaybill(data)">批量打印</c-button>
                    <c-button v-if="auth('b_delivery_light')" color="main" prepend-icon="tf-light" @click="batchControlLight(data)">灯控</c-button>
                    <!--选中态 operate 槽被批量条替换，导出入口须在此复放（同客户/供应商列表先例）；勾选后仅导出选中行-->
                    <c-button v-if="auth('b_delivery_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #receiver_name="{data}">
                    <div v-if="data.receiver_name || data.receiver_phone">
                        <p>{{data.receiver_name || '-'}} {{data.receiver_phone ? '(' + data.receiver_phone + ')' : ''}}</p>
                    </div>
                    <span v-else>-</span>
                </template>

                <template #ship_qty="{data}">

                    {{data.all_qty || data.ship_qty}}
<!--                    <div v-if="data.receiver_name || data.receiver_phone">-->
<!--                        <p>{{data.receiver_name || '-'}} {{data.receiver_phone ? '(' + data.receiver_phone + ')' : ''}}</p>-->
<!--                    </div>-->
<!--                    <span v-else>-</span>-->
                </template>

                <template #ship_state="{data}">
                    <span v-if="data.delivery_result" :class="deliveryResultClass(data.delivery_result)">{{deliveryResultText(data.delivery_result)}}</span>
                    <c-state v-else async dict="DELIVERY_STATE" :value="data.ship_state"></c-state>
                </template>

                <template #create_date="{data}">
                    {{data.create_date || '-'}}
                </template>

                <c-table-column
                    type="button"
                    label="操作"
                    width="180"
                    button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_delivery_print')" :disabled="data.waybill_type != 1 || [4,5,6].indexOf(data.ship_state) != -1 || !data.express_no" icon="tf-print" @click="printDelivery(data)">打印</c-table-button>
                        <c-table-button v-if="auth('b_delivery_ship')" :disabled="(data.delivery_result && data.delivery_result != 0) || [4,5,6].indexOf(data.ship_state) != -1" icon="tf-deliver" @click="shipDelivery(data)">发货</c-table-button>
                        <c-table-button v-if="auth('b_delivery_waybill_cancel')" :disabled="data.waybill_type != 1 || data.ship_state != 3" icon="tf-cancel" @click="cancelWaybill(data)">取消面单</c-table-button>
                        <c-table-button v-if="auth('b_delivery_waybill_cancel')" :disabled="data.ship_state != 1" icon="tf-cancel" @click="closeDelivery(data)">关闭发货单</c-table-button>
                        <c-table-button v-if="auth('b_delivery_ship')" :disabled="!data.delivery_result || data.delivery_result == 0" icon="tf-detail" @click="viewDetail(data)">详情</c-table-button>
                        <c-table-button icon="tf-print" @click="printQcCode(data)">打印质检码</c-table-button>
                    </template>
                </c-table-column>
            </view-list>

            <c-dialog ref="waybillDialog" title="生成电子面单" width="560">
                <div class="m-waybill-address">
                    <div class="m-waybill-address-header">
                        <div class="m-waybill-label">
                            <span class="m-required">*</span>
                            <span>发货地址</span>
                        </div>
                        <c-button size="mini" @click="openAddressManage">选择地址</c-button>
                    </div>
                    <div v-if="selectedAddress" class="m-address-selected">
                        <p class="m-address-info">{{selectedAddress.full_address}}</p>
                        <p class="m-address-contact">{{selectedAddress.name}} {{selectedAddress.phone}}</p>
                    </div>
                    <div v-else class="m-address-empty">请选择发货地址</div>
                </div>

                <div class="m-waybill-selector">
                    <div class="m-waybill-label">
                        <span class="m-required">*</span>
                        <span>请选择电子面单</span>
                    </div>
                    <div class="m-waybill-options">
                        <div
                            v-for="item in waybillOptions"
                            :key="item.value"
                            :class="['m-waybill-option', { 'm-active': selectedWaybill === item.value }]"
                            @click="selectedWaybill = item.value"
                        >
                            <div class="m-waybill-content">
                                <div v-if="item.logo" class="m-waybill-logo" :style="{color: item.color}">{{item.logo}}</div>
                                <div class="m-waybill-name">{{item.name}}</div>
                            </div>
                            <div v-if="selectedWaybill === item.value" class="m-waybill-check">
                                <i class="tf tf-check"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="selectedWaybill === 'DL'" class="m-waybill-logistics">
                    <div class="m-waybill-label">
                        <span class="m-required">*</span>
                        <span>请选择物流公司</span>
                    </div>
                    <c-select v-model="selectedLogisticsType" :options="logisticsTypeOptions" placeholder="请选择物流公司"></c-select>
                </div>

                <template #button>
                    <c-button size="dialog" color="main" :disabled="!selectedWaybill || !selectedAddress || (selectedWaybill === 'DL' && !selectedLogisticsType)" @click="confirmApplyWaybill">确认生成</c-button>
                    <c-button size="dialog" @click="$refs.waybillDialog.close()">取消</c-button>
                </template>
            </c-dialog>

            <c-dialog ref="addressDialog" title="选择发货地址" width="700" @close="addressDialogClose">
                <div class="m-address-list">
                    <div class="m-address-tip">
                        <i class="tf-deliver"></i>点击选择发货地址
                    </div>
                    <div
                        v-for="item in addressList"
                        :key="item.id"
                        :class="['m-address-item', {'m-active': selectedAddress && selectedAddress.id == item.id}]"
                        @click="selectAddress(item)"
                    >
                        <div class="m-address-item-info">
                            <p class="m-address-item-text"><i class="tf-address"></i>{{item.full_address}}</p>
                            <p class="m-address-item-contact">
                                <span class="m-contact-item"><i class="tf-username"></i>{{item.name}}</span>
                                <span class="m-contact-item"><i class="tf-phone"></i>{{item.phone}}</span>
                            </p>
                        </div>
                        <span v-if="item.is_default == 1" class="m-address-item-tag">默认</span>
                        <span class="m-address-item-arrow"><i class="tf-angle-right"></i></span>
                        <span class="m-address-item-check"><i class="tf-check"></i></span>
                    </div>
                    <div v-if="!addressList.length" class="m-address-empty">
                        <img class="m-address-empty-img" src="~@/assets/image/empty.png" alt="">
                        <p class="m-address-empty-text">暂无发货地址</p>
                    </div>
                </div>

                <template #button>
                    <c-button size="dialog" @click="$refs.addressDialog.close()">关闭</c-button>
                </template>
            </c-dialog>

            <!--灯控指令弹窗-->
            <c-dialog ref="lightDialog" width="600px" mask-close @resolve="submitLight">
                <c-form ref="lightForm" vertical unit-width="100%">
                    <c-form-item label="灯型" required>
                        <c-select v-model="lightType" :options="lightTypeOptions" @change="changeLightType"></c-select>
                    </c-form-item>
                    <c-form-item label="颜色" required>
                        <c-select name="colorCode" v-model="lightColorCode" :options="filteredLightColorOptions"
                                  :disabled="!lightType"></c-select>
                    </c-form-item>
                    <c-form-item label="闪灯等待秒数" required>
                        <c-input name="waitingSeconds" type="number" placeholder="请输入等待秒数"></c-input>
                    </c-form-item>
                </c-form>
                <template #button>
                    <c-button size="dialog" color="main" @click="submitLight">确定</c-button>
                    <c-button size="dialog" @click="$refs.lightDialog.close()">取消</c-button>
                </template>
            </c-dialog>

            <c-dialog ref="shipDetailDialog" title="发货详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
                <div class="m-ship-detail-summary" v-if="deliveryDetail.delivery">
                    发货单：{{deliveryDetail.delivery.delivery_no}} 结果：<span :class="deliveryResultClass(deliveryDetail.delivery.delivery_result)">{{deliveryResultText(deliveryDetail.delivery.delivery_result)}}</span>
                </div>
                <c-table :data="deliveryDetail.details" border>
                    <template #empty>
                        <c-empty message="暂无发货明细"></c-empty>
                    </template>
                    <c-table-column label="订单号" width="130">
                        <template #default="{data}">{{data.order_no || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="商品" width="320" :ellipsis="false">
                        <template #default="{data}">
                            <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                        </template>
                    </c-table-column>
                    <c-table-column label="质检码" width="150">
                        <template #default="{data}">
                            <div class="m-qc-cell">
                                <span v-if="data.qc_code">{{data.qc_code}}</span>
                                <span v-else>-</span>
                                <c-table-button v-if="data.qc_code" icon="tf-print" @click="printQcDetail(data)">打印</c-table-button>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column label="发货结果" width="70">
                        <template #default="{data}">
                            <span :class="data.ship_result == 1 ? 'm-ship-success' : 'm-ship-fail'">{{data.ship_result == 1 ? '发货成功' : '发货失败'}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="失败原因" width="200" :ellipsis="false">
                        <template #default="{data}">{{data.fail_reason || '-'}}</template>
                    </c-table-column>
                </c-table>
            </c-dialog>

        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_delivery_list',

        computed: {
            filteredLightColorOptions() {
                let colorCodes = this.lightTypeColorCodeMap[this.lightType] || [];
                return this.lightColorOptions.filter(option => colorCodes.includes(String(option.value)));
            }
        },

        data() {
            return {
                logisticsOptions: [],
                selectedWaybill: '',
                waybillOptions: [
                    {value: 'JD', name: '京东', logo: 'JDL', color: '#e1251b', code: 20001},
                    {value: 'SF', name: '顺丰', logo: 'SF', color: '#333333', code: 20002},
                    {value: 'DL', name: '鼎霖电子面单', logo: '', color: ''}
                ],
                logisticsTypeOptions: [
                    {value: 20001, name: '京东'},
                    {value: 20002, name: '顺丰'}
                ],
                selectedLogisticsType: '',
                addressList: [],
                selectedAddress: null,
                deliveryIds: [],
                waybillDeliveryIds: [],
                lightColorOptions: [],
                lightType: '',
                lightColorCode: '',
                deliveryDetail: {delivery: null, details: []},
                lightTypeOptions: [
                    {name: '单色灯', value: 'single'},
                    {name: '闪烁灯', value: 'flash'},
                    {name: '混色灯', value: 'mixed'}
                ],
                lightTypeColorCodeMap: {
                    single: ['OFF', 'WHITE', 'RED', 'GREEN', 'BLUE'],
                    flash: ['RED_FLASH', 'GREEN_FLASH', 'BLUE_FLASH'],
                    mixed: ['RED_GREEN', 'BLUE_RED', 'BLUE_GREEN']
                }
            }
        },

        mounted() {
            this.loadLogisticsOptions();
            this.loadColorCodeOptions();
        },

        methods: {
            changeLightType() {
                this.lightColorCode = '';
            },

            deliveryResultText(result) {
                return {1: '已发货（全部成功）', 2: '已发货（部分成功）', 3: '已关闭（全部失败）'}[result] || '待发货';
            },

            deliveryResultClass(result) {
                return {1: 'm-ship-success', 2: 'm-ship-partial', 3: 'm-ship-fail'}[result] || '';
            },

            clearLightForm() {
                this.lightType = '';
                this.lightColorCode = '';
                this.$refs.lightForm.clear();
            },

            /*******加载快递公司字典*****************/
            loadLogisticsOptions() {
                this.request({
                    url: '/dic/info/options',
                    data: {
                        dic_type_code: 'LOGISTICS_TYPE'
                    },
                    success: data => {
                        this.logisticsOptions = data || [];
                    }
                });
            },

            /*******打印电子面单（顶部按钮，打印全部查询结果）**********/
            batchApplyWaybill(batchData) {
                var deliveryIds = this.getDeliveryIds(batchData);
                if (!deliveryIds.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                this.request({
                    url: '/sale/delivery/batch/waybill/pending/check',
                    data: {delivery_ids: deliveryIds},
                    loading: true,
                    success: pendingDeliveryIds => {
                        this.waybillDeliveryIds = pendingDeliveryIds || [];
                        this.selectedWaybill = '';
                        this.selectedLogisticsType = '';
                        this.loadAddressList();
                        this.$refs.waybillDialog.open();
                    }
                });
            },

            /** 批量打印已生成的电子面单；未生成面单的发货单由后端自动跳过。 */
            batchPrintWaybill(batchData) {
                var deliveryIds = this.getDeliveryIds(batchData);
                if (!deliveryIds.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                if (deliveryIds.length > 20) {
                    this.$message({message: '单次打印不能超过20条', type: 'warning'});
                    return;
                }

                this.request({
                    url: '/sale/delivery/print/waybill',
                    responseType: 'blob',
                    data: {delivery_ids: deliveryIds},
                    loading: true,
                    success: async response => {
                        try {
                            await this.printWaybillBlob(response);
                        } catch (error) {
                            this.$message({
                                message: error.message || '电子面单打印失败',
                                type: 'warning'
                            });
                        }
                    }
                });
            },

            getDeliveryIds(batchData) {
                var rows = batchData && batchData.length
                    ? batchData
                    : this.$refs.view.$refs.list.getRow('selected');
                return rows.map(row => (row.data || row).id).filter(id => id);
            },

            /*******确认生成电子面单**********/
            confirmApplyWaybill() {
                if (!this.selectedWaybill) {
                    this.$message({message: '请选择电子面单', type: 'warning'});
                    return;
                }

                // 鼎霖电子面单需要选择物流公司
                var providerCode = this.selectedWaybill;
                var logisticsType = '';
                var logisticsName = '';
                if (this.selectedWaybill === 'DL') {
                    if (!this.selectedLogisticsType) {
                        this.$message({message: '请选择物流公司', type: 'warning'});
                        return;
                    }
                    var selectedLogisticsOption = this.logisticsTypeOptions.find(item => item.value == this.selectedLogisticsType);
                    logisticsType = this.selectedLogisticsType;
                    logisticsName = selectedLogisticsOption ? selectedLogisticsOption.name : '';
                } else {
                    var waybillOption = this.waybillOptions.find(item => item.value == this.selectedWaybill);
                    logisticsType = waybillOption.code
                    logisticsName = waybillOption.name
                }

                // 获取选中的发货单ID集合
                var orders = this.waybillDeliveryIds;
                if (!orders || !orders.length) {
                    this.$message({message: '未找到待生成电子面单的发货单', type: 'warning'});
                    return;
                }

                if (orders.length > 20) {
                    this.$message({message: '单次生成不能超过20条', type: 'warning'});
                    return;
                }

                this.request({
                    url: '/sale/delivery/batch/printAndMerge',
                    responseType: 'blob',
                    data: {
                        provider_code: providerCode,
                        delivery_ids: orders,
                        address_id: this.selectedAddress ? this.selectedAddress.id : null,
                        express_company_code: logisticsType,
                        express_company: logisticsName
                    },
                    loading: true,
                    success: async response => {
                        try {
                            await this.printWaybillBlob(response);
                        } catch (error) {
                            this.$message({
                                message: error.message || '批量电子面单打印失败',
                                type: 'warning'
                            });
                            return;
                        }

                        this.$message({message: '操作成功', type: 'success'});
                        // 监听c-table数据加载完成后，重新选中对应行
                        var table = this.$refs.view.$refs.list;
                        var unwatch = table.$watch('rows', () => {
                            unwatch();
                            this.$nextTick(() => {
                                table.getRow('all').forEach(row => {
                                    if (orders.indexOf(row.data.id) !== -1) {
                                        row.select(true);
                                    }
                                });
                            });
                        });
                        this.$refs.view.update();
                    }
                });
            },

            /*******加载发货地址列表**********/
            loadAddressList() {
                this.request({
                    url: '/sys_saas/address/list/noPage',
                    data: {
                        address_type: 1,
                        is_enable: 1
                    },
                    success: data => {
                        this.addressList = data || [];
                        if (!this.selectedAddress) {
                            //默认选中默认地址，无默认地址时选中第一条
                            this.selectedAddress = this.addressList.find(item => item.is_default == 1) || this.addressList[0];
                        }
                    }
                });
            },

            /*******打开发货地址管理**********/
            openAddressManage() {
                this.loadAddressList();
                this.$refs.addressDialog.open();
            },

            /*******选择发货地址**********/
            selectAddress(item) {
                this.selectedAddress = item;
                this.$refs.addressDialog.close();
            },

            /*******地址管理弹窗关闭**********/
            addressDialogClose() {
                // 关闭地址管理弹窗后，如果没有任何选中地址，默认选中默认地址，无默认地址时选中第一条
                if (!this.selectedAddress) {
                    this.selectedAddress = this.addressList.find(item => item.is_default == 1) || this.addressList[0];
                }
            },

            /*******批量发货**********/
            batchShip(batchData) {
                if (!batchData || !batchData.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                var ids = batchData.map(item => item.id);
                this.globalDialog('batchShipDialog', {
                    data: {
                        ids: ids
                    }
                }, () => {
                    this.$refs.view.update();
                });
            },

            /*******加载灯色选项**********/
            loadColorCodeOptions() {
                this.request({
                    url: '/dic/info/options',
                    data: {
                        dic_type_code: 'RACK_COLOR_CODE'
                    },
                    success: data => {
                        this.lightColorOptions = data;
                    }
                });
            },

            /*******打开灯控指令弹窗（无预选商品）**********/
            openLightDialog(batchData) {
                if (!batchData || !batchData.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                this.lightProductCodes = [];
                this.clearLightForm();
                this.$refs.lightDialog.open({title: '下发灯控指令'});
            },

            /*******批量灯控（基于选中行）**********/
            batchControlLight(batchData) {
                if (!batchData || !batchData.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                this.deliveryIds = batchData.map(row => row.id).filter(code => code);
                this.clearLightForm();
                this.$refs.lightDialog.open({title: '下发灯控指令（已选' + this.deliveryIds.length + '条）'});
            },

            /*******提交灯控指令**********/
            submitLight() {
                this.$refs.lightForm.submit({
                    url: '/sale/delivery/lights/by-delivery',
                    rule: {
                        colorCode: '请选择灯色'
                    },
                    dataFormatter: data => {
                        data.delivery_ids = this.deliveryIds;
                        if (data.waitingSeconds) {
                            data.waitingSeconds = parseInt(data.waitingSeconds);
                        } else {
                            delete data.waitingSeconds;
                        }
                        return data;
                    },
                    success: (res, msg) => {
                        this.$refs.lightDialog.close();
                        this.$message({message: '灯控指令已受理', type: 'success'});
                    },
                    fail: (msg) => {
                        this.$message({message: msg, type: 'error'});
                    }
                });
            },

            /** 单行打印复用批量打印接口。 */
            printDelivery(data) {
                this.batchPrintWaybill([data]);
            },

            /** 校验 PDF 数据流并唤起浏览器打印 */
            async printWaybillBlob(response) {
                // 兼容 AxiosResponse 和自定义 request 直接返回响应体两种情况
                let responseData =
                    response &&
                    Object.prototype.hasOwnProperty.call(response, 'data')
                        ? response.data
                        : response;

                let blob;

                if (responseData instanceof Blob) {
                    blob = responseData;
                } else if (responseData instanceof ArrayBuffer) {
                    blob = new Blob([responseData]);
                } else if (ArrayBuffer.isView(responseData)) {
                    blob = new Blob([
                        responseData.buffer.slice(
                            responseData.byteOffset,
                            responseData.byteOffset + responseData.byteLength
                        )
                    ]);
                } else {
                    console.error('接口未返回二进制数据：', responseData);
                    throw new Error('接口未按二进制方式返回电子面单');
                }

                if (!blob.size) {
                    throw new Error('电子面单文件内容为空');
                }

                // 不能只看 Content-Type，后端可能把 JSON/HTML 错误内容标记为 PDF
                const headerText = await this.readWaybillBlobAsText(
                    blob.slice(0, Math.min(blob.size, 1024))
                );

                if (headerText.indexOf('%PDF-') === -1) {
                    const errorText = await this.readWaybillBlobAsText(blob);
                    let message = '后端返回的内容不是有效的 PDF 文件';

                    try {
                        const result = JSON.parse(errorText);
                        message = result.message || message;
                    } catch (error) {
                        console.error('非 PDF 响应内容：', errorText.substring(0, 500));
                    }

                    throw new Error(message);
                }

                // 文件内容确认是 PDF 后再设置 MIME 类型
                const pdfBlob = new Blob([blob], {
                    type: 'application/pdf'
                });

                return this.printPdfBlob(pdfBlob);
            },

            /** 使用隐藏 iframe 打印 PDF Blob */
            printPdfBlob(pdfBlob) {
                return new Promise((resolve, reject) => {
                    const objectUrl = URL.createObjectURL(pdfBlob);
                    const iframe = document.createElement('iframe');
                    let loadTimer;
                    let cleanTimer;
                    let cleaned = false;

                    const cleanup = () => {
                        if (cleaned) return;
                        cleaned = true;
                        clearTimeout(loadTimer);
                        clearTimeout(cleanTimer);
                        if (iframe.parentNode) {
                            iframe.parentNode.removeChild(iframe);
                        }
                        URL.revokeObjectURL(objectUrl);
                    };

                    iframe.style.position = 'fixed';
                    iframe.style.left = '-10000px';
                    iframe.style.top = '0';
                    iframe.style.width = '1px';
                    iframe.style.height = '1px';
                    iframe.style.border = '0';

                    iframe.onload = () => {
                        clearTimeout(loadTimer);
                        setTimeout(() => {
                            try {
                                const printWindow = iframe.contentWindow;
                                printWindow.addEventListener('afterprint', cleanup, {once: true});
                                printWindow.focus();
                                printWindow.print();
                                // 部分浏览器不会触发 afterprint，保留超时清理
                                cleanTimer = setTimeout(cleanup, 60000);
                                resolve(true);
                            } catch (error) {
                                cleanup();
                                reject(new Error('无法唤起PDF打印窗口'));
                            }
                        }, 300);
                    };

                    iframe.src = objectUrl;
                    document.body.appendChild(iframe);

                    loadTimer = setTimeout(() => {
                        cleanup();
                        reject(new Error('PDF打印文件加载超时'));
                    }, 15000);
                });
            },

            /** 兼容旧浏览器的 Blob 文本读取 */
            readWaybillBlobAsText(blob) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = () => resolve(reader.result || '');
                    reader.onerror = () => reject(new Error('读取服务器响应失败'));

                    reader.readAsText(blob);
                });
            },

            /*******单行发货**********/
            shipDelivery(data) {
                this.globalDialog('batchShipDialog', {
                    data: {
                        ids: [data.id]
                    }
                }, () => {
                    this.$refs.view.update();
                });
            },

            cancelWaybill(data) {
                this.$confirm({
                    title: '取消面单',
                    message: '确认取消发货单【' + data.delivery_no + '】的电子面单？取消后不可恢复，发货单将恢复为待发货状态。',
                    cancelButtonName: '暂不取消',
                    loading: true,
                    resolve: () => {
                        this.request({
                            url: '/sale/delivery/cancel/waybill',
                            data: {
                                id: data.id
                            },
                            success: (data, msg) => {
                                this.$message({message: msg || '取消面单成功', type: 'success'});
                                this.$refs.view.update();
                            }
                        })
                    }
                });
            },

            closeDelivery(data) {
                this.$confirm({
                    title: '关闭发货单',
                    message: '确认关闭发货单【' + data.delivery_no + '】？关联订单会恢复待发货并解绑发货单，之后需重新生成发货单。',
                    cancelButtonName: '暂不关闭',
                    loading: true,
                    resolve: () => {
                        this.request({
                            url: '/sale/delivery/close',
                            data: {id: data.id},
                            success: (result, msg) => {
                                this.$message({message: msg || '发货单已关闭', type: 'success'});
                                this.$refs.view.update();
                            }
                        });
                    }
                });
            },

            /*******查看详情**********/
            getProductText(data) {
                return [data.brand_name, data.model_name, data.memory_name, data.color_name]
                    .filter(Boolean).join(' ') || '-';
            },

            /*******打印单条发货明细的质检码标签**********/
            printQcDetail(data) {
                this.printQcLabels([{
                    qc_code: data.qc_code,
                    product_info: this.getProductText(data),
                    imei: data.imei
                }]);
            },

            /*******打印发货单的质检码标签（按发货单查订单商品，未发货也可打印；订单质检码优先，其次发货明细，均无则提示）**********/
            printQcCode(data) {
                this.request({
                    url: '/sale/delivery/order/qc/list',
                    data: {id: data.id},
                    loading: true,
                    success: result => {
                        let items = result || [];
                        let labels = items.filter(item => item.order_qc_code || item.qc_code).map(item => ({
                            qc_code: item.order_qc_code || item.qc_code,
                            product_info: this.getProductText(item),
                            imei: item.imei
                        }));
                        if (!labels.length) {
                            this.$message({message: '该发货单不存在三方质检码', type: 'warning'});
                            return;
                        }
                        this.printQcLabels(labels);
                    }
                });
            },

            viewDetail(data) {
                this.request({
                    url: '/sale/delivery/detail',
                    data: {id: data.id},
                    loading: true,
                    success: result => {
                        this.deliveryDetail = result || {delivery: null, details: []};
                        this.$refs.shipDetailDialog.open();
                    }
                });
            }
        }
    }
</script>

<style scoped lang="stylus">
    .m-waybill-address {
        padding: 10px 16px 0;

        .m-waybill-address-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .m-waybill-label {
                margin-bottom: 0;
                font-size: 14px;
                color: #333;

                .m-required {
                    color: #f5222d;
                    margin-right: 4px;
                }
            }
        }

        .m-address-selected {
            padding: 12px;
            margin-bottom: 12px;
            background: #f6ffed;
            border: 1px solid #b7eb8f;
            border-radius: 4px;

            .m-address-info {
                font-size: 14px;
                color: #333;
                line-height: 22px;
                margin-bottom: 4px;
            }

            .m-address-contact {
                font-size: 13px;
                color: #666;
            }
        }

        .m-address-empty {
            padding: 12px;
            margin-bottom: 12px;
            color: #999;
            font-size: 13px;
            background: #f5f5f5;
            border-radius: 4px;
        }
    }

    .m-ship-detail-summary {
        margin: 12px 12px 16px;
    }
    .m-qc-cell {
        display: flex;
        align-items: center;
    }
    .m-ship-success {
        color: #52c41a;
    }
    .m-ship-partial {
        color: #fa8c16;
    }
    .m-ship-fail {
        color: #f5222d;
    }

    .m-waybill-logistics {
        padding: 10px 16px;

        .m-waybill-label {
            margin-bottom: 10px;
            font-size: 14px;
            color: #333;

            .m-required {
                color: #f5222d;
                margin-right: 4px;
            }
        }

        ::v-deep .c-select {
            width: 100%;
        }
    }

    .m-waybill-selector {
        padding: 10px 16px;

        .m-waybill-label {
            margin-bottom: 16px;
            font-size: 14px;
            color: #333;

            .m-required {
                color: #f5222d;
                margin-right: 4px;
            }
        }

        .m-waybill-options {
            display: flex;
            gap: 16px;
        }

        .m-waybill-option {
            position: relative;
            flex: 1;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s;
            overflow: hidden;

            &:hover {
                border-color: #1890ff;
            }

            &.m-active {
                border-color: #1890ff;
                box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
            }

            .m-waybill-content {
                text-align: center;

                .m-waybill-logo {
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 1.2;
                    font-family: Arial, sans-serif;
                }

                .m-waybill-name {
                    margin-top: 6px;
                    font-size: 13px;
                    color: #333;
                }
            }

            .m-waybill-check {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 24px;
                height: 24px;
                background: #1890ff;
                border-radius: 4px 0 4px 0;
                display: flex;
                align-items: center;
                justify-content: center;

                .tf {
                    color: #fff;
                    font-size: 12px;
                }
            }
        }
    }

    .m-address-list {
        padding: 4px 16px 12px;
        min-height: 150px;
        max-height: 400px;
        overflow-y: auto;

        .m-address-tip {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            padding: 8px 12px;
            font-size: 13px;
            color: #1890ff;
            background: #e6f7ff;
            border: 1px solid #91d5ff;
            border-radius: 4px;

            .tf {
                margin-right: 6px;
            }
        }

        .m-address-item {
            position: relative;
            display: flex;
            align-items: center;
            padding: 14px 44px 14px 16px;
            margin-bottom: 12px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s;

            &:last-child {
                margin-bottom: 0;
            }

            &:hover {
                border-color: #1890ff;
                box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);

                .m-address-item-arrow {
                    color: #1890ff;
                    opacity: 1;
                    transform: translateX(0);
                }
            }

            &.m-active {
                border-color: #1890ff;
                box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);

                .m-address-item-check {
                    display: flex;
                }
            }

            .m-address-item-info {
                flex: 1;
                min-width: 0;

                .m-address-item-text {
                    display: flex;
                    align-items: flex-start;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333;
                    line-height: 22px;
                    margin-bottom: 6px;

                    .tf-address {
                        flex-shrink: 0;
                        margin: 3px 6px 0 0;
                        color: #1890ff;
                        font-size: 15px;
                    }
                }

                .m-address-item-contact {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    font-size: 13px;
                    color: #666;

                    .m-contact-item {
                        display: inline-flex;
                        align-items: center;
                        margin-right: 18px;

                        .tf {
                            margin-right: 4px;
                            color: #bfbfbf;
                            font-size: 13px;
                        }
                    }
                }
            }

            .m-address-item-tag {
                position: absolute;
                top: 0;
                right: 0;
                padding: 2px 10px;
                font-size: 12px;
                line-height: 18px;
                color: #fff;
                background: #1890ff;
                border-radius: 0 4px 0 12px;
            }

            .m-address-item-arrow {
                position: absolute;
                top: 50%;
                right: 14px;
                margin-top: -7px;
                color: #d9d9d9;
                font-size: 14px;
                opacity: 0;
                transform: translateX(-4px);
                transition: all 0.2s;
            }

            .m-address-item-check {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 22px;
                height: 22px;
                display: none;
                align-items: center;
                justify-content: center;
                background: #1890ff;
                border-radius: 12px 0 4px 0;

                .tf-check {
                    color: #fff;
                    font-size: 12px;
                }
            }
        }

        .m-address-empty {
            padding: 40px 0;
            text-align: center;

            .m-address-empty-img {
                width: 120px;
                opacity: 0.8;
            }

            .m-address-empty-text {
                margin-top: 8px;
                color: #999;
                font-size: 14px;
            }
        }
    }
</style>
